import CardSystem from '../CardSystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import { AnimationClipTask } from 'Utility/Task/AnimationClipTask';
import { ReceiveJokerPreBooster } from '../../Animation/Clip/ReceiveJokerPreBooster';

export default async function ReceiveJokerPreBoosterAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): Promise<void> {
    const jokerCard = system.getCardByID(taskData.cards[0]);
    system.taskQueue.queue(new AnimationClipTask(new ReceiveJokerPreBooster(jokerCard, {
        system
    })));
}
